import PropTypes from 'prop-types';
import getRAG from '../../utils/ragStatus.js';
import {
    formatKpiValue,
    kpiHasRecordedValue
} from '../../utils/executive-pulse-kpi-value.js';
import ProgressBar from './ProgressBar.jsx';
import KpiTrendChart from './KpiTrendChart.jsx';

const STATUS_CLASS = {
    green: 'kpi-card--green',
    yellow: 'kpi-card--yellow',
    red: 'kpi-card--red',
    gray: 'kpi-card--gray'
};

export default function KPICard({ item, reportingPeriod, onClick }) {
    const { status, label } = getRAG(item, reportingPeriod);
    const statusClass = STATUS_CLASS[status] || STATUS_CLASS.gray;

    return (
        <button
            type="button"
            className={`kpi-card ${statusClass}`}
            onClick={() => onClick?.(item)}
            aria-label={`${item.title}, view details and history`}>
            <div className="kpi-card__head">
                <span className="kpi-card__title">{item.title}</span>
                <span
                    className={`kpi-card__status kpi-card__status--${status}`}>
                    {label}
                </span>
            </div>

            <div className="kpi-card__metrics">
                <span
                    className={`kpi-card__value${
                        kpiHasRecordedValue(item)
                            ? ''
                            : ' kpi-card__value--empty'
                    }`}>
                    {formatKpiValue(item)}
                </span>
                <span className="kpi-card__target">Target {item.target}</span>
            </div>

            <KpiTrendChart
                item={item}
                reportingPeriod={reportingPeriod}
                status={status}
                variant="compact"
            />

            <ProgressBar
                value={kpiHasRecordedValue(item) ? item.value : null}
                target={item.target}
                status={status}
                empty={!kpiHasRecordedValue(item)}
            />

            <span className="kpi-card__foot">
                Click for history &amp; logging
            </span>
        </button>
    );
}

KPICard.propTypes = {
    item: PropTypes.shape({
        kpiId: PropTypes.string,
        title: PropTypes.string.isRequired,
        value: PropTypes.number,
        target: PropTypes.number,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        series: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.number,
                date: PropTypes.string
            })
        ),
        seriesSource: PropTypes.string,
        source: PropTypes.string
    }).isRequired,
    reportingPeriod: PropTypes.object,
    onClick: PropTypes.func
};
